(function () {
  const GRID_PRODUCT_SELECTOR = 'product-grid-item[data-product-handle]';
  const LABEL_MARK = 'data-aw-labels-loaded';

  const state = window.awLabels || (window.awLabels = {
    tagsCache: {},
    requests: {}
  });

  const fetchTags = (handle) => {
    if (state.tagsCache[handle]) return Promise.resolve(state.tagsCache[handle]);
    if (state.requests[handle]) return state.requests[handle];

    state.requests[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(r => r.ok ? r.json() : null)
      .then(product => {
        const tags = product ? product.tags : [];
        state.tagsCache[handle] = tags;
        return tags;
      })
      .catch(() => [])
      .finally(() => { delete state.requests[handle]; });

    return state.requests[handle];
  };

  const buildLabelsHtml = (tags) => {
    const items = tags.reduce((acc, tag) => {
      if (tag.startsWith('lbl_red_')) {
        acc += `<li style="background:#B00000;">${tag.replace('lbl_red_', '')}</li>`;
      } else if (tag.startsWith('lbl_black_')) {
        acc += `<li style="background:#000000;">${tag.replace('lbl_black_', '')}</li>`;
      }
      return acc;
    }, '');
    return items ? `<ul class="aw-labels">${items}</ul>` : '';
  };

  const fillLabels = (root = document) => {
    root.querySelectorAll(`${GRID_PRODUCT_SELECTOR}:not([${LABEL_MARK}])`).forEach(card => {
      const handle = card.dataset.productHandle;
      const meta = card.querySelector('.grid-item__meta');
      if (!handle || !meta) return;

      // すでにaw-labelsがある場合はスキップ
      if (meta.querySelector('.aw-labels')) {
        card.setAttribute(LABEL_MARK, '');
        return;
      }

      card.setAttribute(LABEL_MARK, '');

      fetchTags(handle).then(tags => {
        if (!card.isConnected) return;
        const html = buildLabelsHtml(tags);
        if (!html) return;
        const latestMeta = card.querySelector('.grid-item__meta');
        if (!latestMeta || latestMeta.querySelector('.aw-labels')) return;
        latestMeta.insertAdjacentHTML('afterbegin', html);
      });
    });
  };

  const observe = () => {
    const root =
      document.querySelector('#CollectionAjaxContent') ||
      document.querySelector('#gf-grid') ||
      document.body;

    new MutationObserver(mutations => {
      let hit = false;
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (
            node.matches?.(GRID_PRODUCT_SELECTOR) ||
            node.querySelector?.(GRID_PRODUCT_SELECTOR)
          ) hit = true;
        });
      });
      if (hit) requestAnimationFrame(() => fillLabels(document));
    }).observe(root, { childList: true, subtree: true });
  };

  const init = () => {
    fillLabels(document);
    observe();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('page:loaded', init);
})();
